var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-900 grid lg:grid-cols-2 grid-cols-1 space-around"},[_c('app-profile',{key:_vm.student.id,staticClass:"static h-screen",attrs:{"student":_vm.student}}),_vm._v(" "),_c('app-facts',{staticClass:"relative",attrs:{"facts":_vm.facts}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13db8472","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profiles/single/Container.vue
// module id = null
// module chunks = 